export default {"src":"/_next/static/media/moonboon-logo.18dbb57a.svg","height":199,"width":651,"blurWidth":0,"blurHeight":0};